import type { PlaceMarkerAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { YinshState } from "../types/game-state";
import { getCellContent } from "../utils/board-utils";

export function validatePlaceMarker(
  state: YinshState,
  action: PlaceMarkerAction,
): ValidationResult {
  if (state.phase !== "PLAYING") {
    return { valid: false, error: "Not in playing phase" };
  }
  if (action.player !== state.currentPlayer) {
    return { valid: false, error: "Not your turn" };
  }
  if (state.markerPlacedAt !== null) {
    return { valid: false, error: "Already placed a marker this turn" };
  }
  if (state.markersPool <= 0) {
    return { valid: false, error: "No markers remaining in pool" };
  }
  const cell = getCellContent(state.board, action.ringPosition);
  if (cell?.type !== "RING" || cell.player !== action.player) {
    return { valid: false, error: "No friendly ring at that position" };
  }
  return { valid: true };
}
